export default class VocalAssistant {
    constructor(arg = undefined) {
        if(!window.webkitSpeechRecognition) return;

        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = arg[c.nome] != undefined
                    ? c.complex === false ? arg[c.nome]
                        : JSON.parse(JSON.stringify(arg[c.nome])) : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }

        this.recognition.continuous = true;
        this.recognition.onresult = this.handleRecognition.bind(this);
        this.recognition.onend = this.endRecognition.bind(this);
        this.recognition.lang = "it-IT";
        /*this.recognition.onspeechstart = ()=>{
            console.log("cippalippa");
        };
        const grammar = new window.webkitSpeechGrammarList();
        grammar.addFromString("Mistagogo", 1);
        this.recognition.grammars = grammar;
        this.recognition.onnomatch = () => {
            console.log("no match.");
        }*/
    }
    detectCommand(cmd) {
        let res = false;
        switch (cmd) {
            case "COSTRUISCI STRINGA.":
                {
                    this.modalita = "costruisci_stringa";
                    const evento = new CustomEvent("start_string", { detail: null });
                    document.getElementById("listener_aggiunta_riga_generale").dispatchEvent(evento);

                    res = true;
                }
                break;
            case "REINDIRIZZA HOME.":
                {
                    this.rispondi("torno alla pagina home");
                    const messaggio = { detail: { rotta: "/home/dashboard" }, src: null };
                    const evento = new CustomEvent("redirect", messaggio);
                    document.getElementById("inspire_main").dispatchEvent(evento);
                    res = true;
                }
                break;
            case "TERMINA COSTRUISCI STRINGA.":
                {
                    this.modalita = "";

                    const evento = new CustomEvent("stop_string", { detail: null });
                    document.getElementById("listener_aggiunta_riga_generale").dispatchEvent(evento);

                    res = true;
                }
                break;
            default:
                break;
        }

        return res;
    }
    endRecognition() {
        if (this.attivo) {
            this.recognition.start();
        }
    }
    executeCommand(args) {
        switch (this.modalita) {
            case "costruisci_stringa":
                {
                    const testo = args.replaceAll("POI", "\n");
                    const messaggio = { detail: { testo: testo }, src: null };
                    const evento = new CustomEvent("append_string", messaggio);
                    document.getElementById("listener_aggiunta_riga_generale").dispatchEvent(evento);

                    this.rispondi("ho capito" + testo.toLowerCase());
                }
                break;
            default:
                break;
        }
    }
    handleRecognition(event) {
        // Registro quello che l'utente ha detto.
        const speech = event.results[0][0].transcript
            .toUpperCase()
            /*.replaceAll(".", "")*/
            .replaceAll(",", "");
        console.log(speech);
        //console.log(event);

        // Vedo se contiene un comando.
        const command = this.detectCommand(speech);

        /* Se l'utente non ha passato un comando, vedo
         * se ha passato argomenti di un comando precedente. */
        if (!command) {
            this.executeCommand(speech);
        }

        /* Fermo la registrazione, che viene ripresa automaticamente 
         * dopo essersi fermata se attivo vale ancora true. */
        this.recognition.stop();

        if (!speech.toUpperCase().includes("stop".toUpperCase())) {
            this.attivo = true;
        } else {
            this.attivo = false;
            this.rispondi("chiudo il canale di ascolto");
        }
    }
    startRecognition() {
        this.recognition.start();
        this.rispondi("quick view è in ascolto");
        console.log("In ascolto...");
    }
    // Metodo per resettare tutte i campi
    reset() {
        const campi = this.setControlli();
        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }
    rispondi(arg) {
        const synth = window.speechSynthesis;
        const voices = synth.getVoices();
        const utterThis = new SpeechSynthesisUtterance(arg);
        utterThis.voice = voices.filter(elem => elem.lang == "it-IT")[0];
        utterThis.pitch = 1;
        utterThis.rate = 0.8;
        synth.speak(utterThis);
    }

    setCampi() {
        const campi = [
            { nome: "attivo", default_val: false, complex: false },
            { nome: "recognition", default_val: new window.webkitSpeechRecognition(), complex: false },
        ];
        return campi;
    }
}